import React, { Component } from 'react'
import { Button, Form, Container, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { editNote } from '../redux/actions'
import _ from 'lodash'

//const HOME_PATH = '/'
const HOME_PATH = '/inCyberNotes'

class NoteEdit extends Component {
  state = {
    title: '', // this.props.note.title,
    body: '', // this.props.note.body
    showMsg: false,
  }

  componentDidMount() {
    const { title, body } = this.props.note
    this.setState(() => ({
      title,
      body
    }))
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  doneMsg = () => {
    setTimeout(() => {

      this.setState({
        showMsg: false
      })
      this.props.history.push(HOME_PATH)

    }, 3000)
    return (
      <Message positive>
        <Message.Header>Your note has been updated with success!</Message.Header>
        <p>Please wait while we redirect you to the <b>homepage</b></p>
      </Message>
      )
  }

  backHome = () => {
    this.props.history.push(HOME_PATH)
  }

  handleSubmit = event => {
    event.preventDefault()
    const id = _.get(this.props, 'match.params.id', 'invalid')
    const note = {
      title: this.state.title,
      body: this.state.body,
    }
    this.props.editNote(id, note)
    this.setState(() => ({
      showMsg: true
    }))
  }

  formLoading = () => {
    return (
      <Form loading={this.state.showMsg} onSubmit={this.handleSubmit}>
        <Form.Input
          label="Title"
          name="title"
          type="text"
          placeholder="Title"
          value={this.state.title}
          onChange={this.handleChange}
        />
        <div className="field">
          <label>Short Text</label>
          <textarea
            name='body'
            onChange={this.handleChange}
            value={this.state.body}
            type="text"
            placeholder="body"
            rows="2"
          />
        </div>
        <Button>Update</Button>
        <Button
          onClick={this.backHome}
          type='button'
          className="ui violet basic button">
          Back
        </Button>
      </Form>
    )
  }

  render() {
    return (
      <div style={{ marginTop: '7rem' }}>
        <Container>
          {this.formLoading()}
          {this.state.showMsg && (
            this.doneMsg()
          )}
          </Container>
      </div>
    )
  }
}

function mapState(state, ownProps) {
  return {
    note: state.notes[ownProps.match.params.id]
  }
}

export default withRouter(connect(mapState, { editNote })(NoteEdit))



// WEBPACK FOOTER //
// ./src/components/NoteEdit.js